export const newAttachmentFileName = (state) => {
  return state.ticket.newAttachmentFileName
}

export const isAttachmentUploadError = (state) => {
  return state.ticket.isAttachmentUploadError
}

export const attachmentUploadFileName = (state) => {
  return state.ticket.attachmentUploadInfo.uploadFileName
}

export const attachmentUploadTotalBytes = (state) => {
  return state.ticket.attachmentUploadInfo.uploadTotalBytes
}

export const attachmentUploadCurrentBytes = (state) => {
  return state.ticket.attachmentUploadInfo.uploadCurrentBytes
}

export const isUpdating = (state) => {
  return state.ticket.isUpdating
}
